const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4000';
  }
  return 'https://gestareducativa-v2.onrender.com';
};

export const getCaptchValue = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/captcha`);
    const data = await response.json();
    return data.captcha;
  } catch (error) {
    console.log(`(getCaptchValue): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const verifyCaptchaInput = async (captchaInput) => {
  try {
    console.log(captchaInput);
    
    const response = await fetch(`${getBaseUrl()}/gestar-api/verify-captcha`,{
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ captchaInput }),
    });
    const data = await response.json();
    return data?.success;
  } catch (error) {
    console.log(`(getCaptchValue): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getCategories = async (type) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/categories/get-all/${type}`);
    const data = await response.json();
    return data.tables;
  } catch (error) {
    console.log(`(getCAtegories): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getCoursesInfo = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/courses/get-all`);
    const data = await response.json();
    return data.tables
  } catch (error) {
    console.log(`(getCategories): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getAllByTableName = async (table) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/see-all/${table}`);
    const data = await response.json();
    return data.tables;
  } catch (error) {
    console.log(`(getAllByTableName): Error on attempting to fetch. Msg: ${error.message}`);
  }
}
export const getCourseById = async (courseId) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/courses/get-by-id/${courseId}`);
    const data = await response.json();
    return data.tables[0]
  } catch (error) {
    console.log(`(getCAtegories): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getCoursesForTrayectory = async (IdCurso) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/courses/get-for-trayectory?IdCurso=${IdCurso}`);
    const data = await response.json();
    return data.tables
  } catch (error) {
    console.log(`(getCoursesForTrayectory): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getTrayectoryInfo = async (IdCurso, IdCategoria, isSingleCourse) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/courses/get-trayectory-info?IdCurso=${IdCurso}&IdCategoria=${IdCategoria}&isSingleCourse=${isSingleCourse}`);
    const data = await response.json();
    return data.tables
  } catch (error) {
    console.log(`(getTrayectoryInfo): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getCoursesByCategory = async (categoryName) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/courses/get-by-category-name/${categoryName}`);
    const data = await response.json();
    return data.tables
  } catch (error) {
    console.log(`(getCAtegories): Error on attempting to fetch. Msg: ${error.message}`);
  }
};
export const getBenefits = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/benefits/get-all`);
    const data = await response.json();
    return data.tables;
  } catch (error) {
    console.log(`(getBenefits): Error on attempting to fetch. Msg: ${error.message}`);
  }
}
export const getModes = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/modes/get-all`);
    const data = await response.json();
    return data.tables;
  } catch (error) {
    console.log(`(getBenefits): Error on attempting to fetch. Msg: ${error.message}`);
  }
}
export const getCompositions = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/composition/get-all`);
    const data = await response.json();
    return data.tables;
  } catch (error) {
    console.log(`(getBenefits): Error on attempting to fetch. Msg: ${error.message}`);
  }
}
export const getVercel = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/vercel/get-all-imgs`);
    const formatteddData = await response.json();
    return formatteddData.data;
  } catch (error) {
    console.log(`(getVercel): Error on attempting to fetch. Msg: ${error.message}`);
  }
}
export const sendFormData = async (data) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/leads/set-data`,{
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  } catch (error) {
    console.log(`(sendFormData): Error on attempting to fetch. Msg: ${error.message}`);
  }
};

export const registerSearch = async (termino, origen = null, dispositivo = null, resultados = null) => {
  try {
    const response = await fetch(`${getBaseUrl()}/gestar-api/searches/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        termino_busqueda: termino,
        origen,
        dispositivo,
        resultados
      }),
    });
    return response.ok;
  } catch (error) {
    console.log(`(registerSearch): Error al registrar búsqueda. Msg: ${error.message}`);
  }
};
